import { render, staticRenderFns } from "./BankValuation.vue?vue&type=template&id=06d3243a&scoped=true"
import script from "./BankValuation.vue?vue&type=script&lang=js"
export * from "./BankValuation.vue?vue&type=script&lang=js"
import style0 from "./BankValuation.vue?vue&type=style&index=0&id=06d3243a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d3243a",
  null
  
)

export default component.exports